const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/uster/eCheckin/sections/components/metakat/Versicherung/KostentraegerField.tsx';
import React, { forwardRef } from 'react';
import { useCIS4m } from '@cistec/common_web/modules/CIS4m/hooks';
import { CIS4mMetaKatDropDown } from '@cistec/common_web/modules/CIS4m/components/CIS4mMetaKatDropDown';
import { useCIS4FormMetaKatData } from 'App/store/cis4m';
import { TextInput } from '@cistec/common_web/utils/intlUtils';
import { useIntl } from 'react-intl';

interface Props {
    label: TextInput;
    path: string;
    hidden?: boolean;
    required?: boolean;
}

export const KostentraegerField = forwardRef((props: Props, ref: any) => {
    const { locale } = useIntl();
    const dropdownRef = useCIS4m(ref);

    const hidden = props.hidden ?? false;
    const required = props.required ?? false;

    return (
        <CIS4mMetaKatDropDown
            ref={dropdownRef}
            label={props.label}
            path={props.path}
            pcode={'43142190-b490-46e7-8e22-c6d8b862bfa0'}
            valuePath="FKEY"
            labelPath={`CONTENT.Lang.${locale}`}
            hidden={hidden}
            required={required}
            dataHook={useCIS4FormMetaKatData}
        />
    );
});

KostentraegerField.displayName = 'KostentraegerField';
